import React from 'react'
import YnsIcon from '~/components/icons/YnsIcon'
import useTranslation from '../shared/TranslationProvider'

const PROGRAM_LEVELS_WITH_COACHING = [
  'GOLD',
  'ADVANCE',
  'SELECT',
  'CONCIERGE',
  'ESSENTIALS',
  'EXECUTIVE',
  'PROFESSIONAL',
]

const Features = ({ programLevel }) => {
  const { t } = useTranslation('PreUpgradeDialog')
  const features = [
    {
      icon: 'ayla',
      title: t('features.ayla.title'),
      description: t('features.ayla.description'),
    },
    {
      icon: 'coach-services',
      title: t('features.coach_services.title'),
      description: PROGRAM_LEVELS_WITH_COACHING.includes(programLevel)
        ? t('features.coach_services.description_coaching')
        : t('features.coach_services.description'),
    },
    {
      icon: 'document',
      title: t('features.document.title'),
      description: t('features.document.description'),
    },
  ]

  return (
    <>
      <div className="text-xl font-bold">{t('key_features')}</div>
      {features.map((feature) => (
        <div className="flex items-center gap-4" key={feature.title}>
          <YnsIcon name={feature.icon} className="!h-14 !w-14" />
          <div className="flex flex-col gap-2">
            <div className="text-xl font-medium">{feature.title}</div>
            <div className="text-base">{feature.description}</div>
          </div>
        </div>
      ))}
    </>
  )
}

export default Features
